import { colors } from "../stockManagement/ColorWish";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "../../../styles/stores/mystores.css";
import { ButtonLoader } from "../../../components/uxCollections/Loaders";
import { generateAdUrl } from "../../../api/endpoints";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";
const unwantedChars = ["e", "E", "-", ".", "+"];

const GenerateAdWithAI = ({ closeModal, setGeneratedAiAd, setAdImage, setIsadvertAiGenerated }) => {
  const [defautParams, setDefautParams] = useState({
    adBackgroundColor: "brown",
    discount: null,
    model: null,
  });
  const [generatedAdvert, setGeneratedAdvert] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const { store } = useSelector((state) => state.store);

  useEffect(() => {
    if (parseInt(defautParams.discount) >= 2 && defautParams.adBackgroundColor && defautParams.model) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [defautParams]);

  const generateAdvertFun = async () => {
    setIsLoading(true);
    let payload = {
      shopName: store.storeName,
      shopCategory: store.category,
      modelToShow: defautParams.model,
      storeLink: store.storeLink,
      discount: defautParams.discount,
      backgroundColor: defautParams.adBackgroundColor,
    };

    try {
      let response = await fetch(generateAdUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        let { advertUrl } = await response.json();
        setGeneratedAdvert(advertUrl);
        setIsLoading(false);
      } else {
        uiAlert("Error generating advert, please try again", "error");
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const useGeneratedLogo = () => {
    setGeneratedAiAd(generatedAdvert);
    closeModal(false);
    setAdImage(generatedAdvert);
    setIsadvertAiGenerated(true);
  };

  return (
    <div className='createStore'>
      <div style={{ marginTop: "80px" }} className='formToGenIm'>
        <div className='logoDisplay33'>
          <img
            style={{ width: "185px", height: "140px" }}
            src={
              generatedAdvert
                ? generatedAdvert
                : "https://res.cloudinary.com/ebuka1122/image/upload/v1668594398/samples/Ihub-Consumer-App/Rectangle_1644_qqzkco.png"
            }
          />
        </div>
        <h3 className='grnTitlt33'>Complete form to generate Ad </h3>
        <div className='inputFieldAnimated passwordIn poxdrr'>
          <input
            value={defautParams.discount}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length === 0) {
                setDefautParams({ ...defautParams, discount: null });
                return;
              }
              const lastChar = value[value.length - 1];
              if (unwantedChars.includes(lastChar)) {
                return;
              }
              if (parseInt(value) > 100) {
                return;
              }
              setDefautParams({ ...defautParams, discount: parseInt(value) });
            }}
            style={{
              paddingLeft: "20px",
              paddingTop: "0",
              width: "100%",
            }}
            type={"number"}
            required={true}
            min='0'
            max='100'
          />
          <p
            style={{
              top: "14px",
              left: "20px",
            }}
          >
            discount offered (2% minimum)*
          </p>
          <div style={{ marginRight: "10px" }}>%</div>
        </div>
        <div className='inputFieldAnimated passwordIn poxdrr'>
          <select value={defautParams.model} onChange={(e) => setDefautParams({ ...defautParams, model: e.target.value })} className='selectModel22'>
            <option value='' disabled selected hidden>
              Choose a model to show
            </option>
            <option> Black man</option>
            <option>Black woman</option>
            <option>White man</option>
            <option>White woman</option>
            <option>Asian</option>
            <option>Indian</option>
          </select>
        </div>
        <div className='selectColor122'>
          <span style={{ backgroundColor: defautParams.adBackgroundColor }}></span>
          <div>
            <select onChange={(e) => setDefautParams({ ...defautParams, adBackgroundColor: e.target.value })}>
              <option value='' disabled selected hidden>
                Advert color
              </option>
              {colors.map((color, i) => {
                return (
                  <option key={i} className='flexColorDiv22'>
                    <span style={{ backgroundColor: `${color.name}` }}></span>
                    <p> {color.name} </p>
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        {generatedAdvert ? (
          <button onClick={useGeneratedLogo} className='genBTnLog'>
            {" "}
            Use logo as store logo{" "}
          </button>
        ) : isFormValid ? (
          isLoading ? (
            <button style={{ opacity: "0.7" }} className='genBTnLog'>
              {" "}
              <ButtonLoader />{" "}
            </button>
          ) : (
            <button onClick={generateAdvertFun} className='genBTnLog'>
              {" "}
              Generate logo with AI{" "}
            </button>
          )
        ) : (
          <button style={{ opacity: "0.6", cursor: "not-allowed" }} className='genBTnLog'>
            {" "}
            Generate logo with AI{" "}
          </button>
        )}

        {
          <button style={{ opacity: isLoading ? "0.7" : "" }} onClick={() => !isLoading && closeModal(false)} className='returnUploadLof'>
            {" "}
            Upload my logo instead{" "}
          </button>
        }
      </div>
    </div>
  );
};

export default GenerateAdWithAI;
